import css from 'styled-jsx/css';

const styles = css.global`#santander-c2c {
    background: linear-gradient(0deg,
            #900 50%,
            #C00 50%);
}

#santander-c2c .santander-c2c-contain {
    /* max-width: 290px; */
    margin: auto;
}

#santander-c2c .card-c2c.comprar {
    background: #C00;
}

#santander-c2c .card-c2c.vender {
    background: #900;
}

#santander-c2c .card-c2c {
    padding: 24px 0 44px;
    /* min-height: 469px; */
    display: inline-block;
}

#santander-c2c .card-c2c img {
    border-radius: 4px;
    width: 100%;
    object-fit: contain;
}

#santander-c2c .card-c2c .c2c-title {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
    margin: 11px 0 8px;
}

#santander-c2c .card-c2c .c2c-text,
#santander-c2c .card-c2c .c2c-text b  {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#santander-c2c .card-c2c .c2c-link {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    margin-top: 16px;
    display: inline-block;
}

/* @media (min-width: 485px) {
    #santander-c2c .card-c2c {
        min-height: 576px;
        padding: 50px 0;
    }
} */

@media (min-width: 800px) {
    #santander-c2c {
        background: linear-gradient(270deg,
                #900 50%,
                #C00 50%);
    }
    #santander-c2c .santander-c2c-contain {
        display: flex;
        justify-content: space-between;
        max-width: 100%;
    }
    #santander-c2c .card-c2c {
        width: calc(50% - 45px);
        padding: 48px 0 68px;
    }
    #santander-c2c .card-c2c img {
        max-height: none;
    }
    #santander-c2c .card-c2c .c2c-text b {
        font-weight: 600;
        line-height: 28px;
    }
}

@media (min-width: 1280px) {
    #santander-c2c .card-c2c {
        width: 500px;
    }

    #santander-c2c .card-c2c .c2c-title {
        font-size: 32px;
        line-height: 48px;
        margin: 38px 0 16px;
    }
    
}`;

export default styles;